export default "__VITE_ASSET__Qcel4PxG__"